export const DEFAULT_STORE = 'Utrecht';

export const DEFAULT_MAKER_NAME = 'Paul';

export const BIKEFLIP_BACKEND_HOSTS = [
  'backend.bikeflip.nl',
  'backend-staging.bikeflip.nl',
  'localhost'
];
